"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/DropdownParticipantsPicker/SuggestionBox.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _EntityAvatar = require('./EntityAvatar'); var _EntityAvatar2 = _interopRequireDefault(_EntityAvatar);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);























const isAction = (item) =>
  'text' in item && !!item.text

const isSection = (item) =>
  'entities' in item && !!item.entities

/* --------------------------------
   [private] SelectionBox Sub-Component
----------------------------------- */





const SelectionBoxItem = ({ entity, onOptionSelected }) => {
  return (
    _react2.default.createElement('div', { className: "suggestion-box--item", onClick: () => onOptionSelected(entity), __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
      , _react2.default.createElement('div', { className: "suggestion-box--item-leftside", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        , _react2.default.createElement(_EntityAvatar2.default, {
          entityType: entity.type,
          avatar: entity.avatar,
          size: 36, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
          )
      )
      , _react2.default.createElement('div', { className: "suggestion-box--item-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        , _react2.default.createElement('div', { className: "suggestion-box--item-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, entity.title)
        , _react2.default.createElement('div', { className: "suggestion-box--item-subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, entity.subtitle)
      )
      , entity && entity.icon ? (_react2.default.createElement('div', { className: "suggestion-box--item-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
        , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "check")
      )) : null
    )
  )
}

/* --------------------------------
   [private] SelectionBox action
----------------------------------- */





const SelectionBoxAction = ({ text, onClick }) => {
  return (
    _react2.default.createElement('div', { className: "suggestion-box--item", onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
      , _react2.default.createElement('div', { className: "suggestion-box--item-leftside", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        , _react2.default.createElement('div', { className: "suggestion-box--action", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
          , _react2.default.createElement('img', { src: "/assets/icons/icon-add-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}})
        )
      )
      , _react2.default.createElement('div', { className: "suggestion-box--item-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
        , _react2.default.createElement('div', { className: "suggestion-box--item-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, text)
      )
    )
  )
}

/* --------------------------------
    [public] SuggestionBox Component
----------------------------------- */













const defaultTabType = "ALL"

const SuggestionBox = ({
  options,
  open,
  onOptionSelected,
  onActionSelected,
  onClickedOutsideBox,
  onMouseEnter,
  onMouseLeave,
  showTabs = false,
  style,
  className,
}) => {
  const [selectedType, setSelectedType] = _react.useState.call(void 0, defaultTabType)
  const boxRef = _react.useRef(null)

  // componentDidUpdate: return to the default tab when the box closes.
  const [prevOpen, setPrevOpen] = _react.useState.call(void 0, open)
  if (prevOpen !== open) {
    setPrevOpen(open)
    if (prevOpen && !open) {
      setSelectedType(defaultTabType)
    }
  }

  // The document listener lives from mount to unmount and reads the latest
  // onClickedOutsideBox.
  const onClickedOutsideBoxRef = _react.useRef.call(void 0, onClickedOutsideBox)
  _react.useLayoutEffect.call(void 0, () => {
    onClickedOutsideBoxRef.current = onClickedOutsideBox
  })

  _react.useEffect.call(void 0, () => {
    const handleWindowClick = (evt) => {
      if (!onClickedOutsideBoxRef.current) {
        return
      }

      if (!boxRef.current) {
        return
      }

      // SAFETY: a click event's target is a DOM node.
      if (boxRef.current.contains(evt.target )) {
        return
      }

      onClickedOutsideBoxRef.current(evt)
    }
    document.addEventListener('click', handleWindowClick)
    return () => document.removeEventListener('click', handleWindowClick)
  }, [])

  const preventClose = (evt) => {
    evt.stopPropagation()
  }

  const mouseEnter = () => {
    if (onMouseEnter) {
      onMouseEnter()
    }
  }

  const mouseLeave = () => {
    if (onMouseLeave) {
      onMouseLeave()
    }
  }

  const selectedOption = options[selectedType]
  if (!selectedOption) {
    return null
  }

  /* We use this class to induce a "display: none;" and maintain the prop */
  const classes = ["suggestion-box"]
  if (!open) {
    classes.push("suggestion-box--closed")
  }

  if (className) {
    classes.push(className)
  }

  const items = selectedOption.items.map((item, i) => {
    if (isAction(item)) {
      /* this is an aciton */
      return (
        _react2.default.createElement(SelectionBoxAction, { key: i, text: item.text, onClick: () => onActionSelected(item.id), __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}})
      )
    }

    if (!isSection(item)) { /* not a section, continue */
      return (
        _react2.default.createElement(SelectionBoxItem, {
          key: i,
          entity: item,
          onOptionSelected: onOptionSelected, __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}})
      )
    }
    if (item.entities.length < 1) {
      return null
    }

    return (
      _react2.default.createElement('div', { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}}
        , item.title ? _react2.default.createElement('div', { className: "suggestion-box--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}, item.title) : null 
        , item.entities.map((e, k) => _react2.default.createElement(SelectionBoxItem, { key: k, entity: e, onOptionSelected: onOptionSelected, __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}} ))
      )
    )
  })

  return (
    _react2.default.createElement('div', { className: classes.join(" "),
      style: { ...style },
      ref: boxRef,
      onClick: preventClose,
      onMouseEnter: mouseEnter,
      onMouseLeave: mouseLeave, __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}
      , showTabs && _react2.default.createElement('div', { className: "suggestion-box--tabs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}
        , Object.values(options).map((option, i) => (
          _react2.default.createElement('div', { key: i,
            className: _classBuilder2.default.call(void 0, "suggestion-box--tab-item", { 'selected': selectedType === option.id }),
            onClick: () => setSelectedType(option.id), __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}}
            , option.tabName
          )
        ))
      )
      , _react2.default.createElement('div', { className: "suggestion-box--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}
        , items
        , items.length === 0 && (
          _react2.default.createElement('div', { className: "suggestion-box--message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 233}}, "No Results found"

          )
        )
      )
    )
  )
}

exports. default = SuggestionBox
